import React, { useContext } from "react";
import styled from "styled-components";
import { useTheme, Typography } from "@material-ui/core";

import Logo from "../../../assets/Logo";
import HeaderButtons from "./HeaderButtons";
import SiteChooser from "./SiteChooser";
import { UserContext } from "../../../contexts/UserContext";

function Header() {
  const { Site, Sites, userRole } = useContext(UserContext);
  const { palette } = useTheme();
  return (
    <Container borderColour={palette.secondary.main}>
      <Logo accent={palette.secondary.main} text={palette.text.primary} />
      {Sites != undefined ? (
        Sites.length > 1 || userRole === "admin" ? (
          <SiteChooser />
        ) : (
          <SiteName variant="h4" align="center">
            {Site.name}
          </SiteName>
        )
      ) : (
        <SiteName variant="h4" align="center">
          {Site.name}
        </SiteName>
      )}

      <HeaderButtons />
    </Container>
  );
}

const Container = styled.header`
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
  padding: 2rem 6rem;
  border-bottom: 1px solid ${(props) => props.borderColour};
  margin-bottom: 4rem;
  .logo {
    height: 70px;
  }
`;

const SiteName = styled(Typography)`
  flex: 1;
`;

export default Header;
